export const maritalStatusOptions = {
    'SOL': {name: 'Soltero/a'},
    'CAS': {name: 'Casado/a'},
    'DIV': {name: 'Divorciado/a'},
    'VIU': {name: 'Viudo/a'},
    'CON': {name: 'Conviviente'}
};